var map = {
	"./freshwater/arapaima/2.jpg": "2459",
	"./freshwater/beluga-sturgeon/2.jpg": "d489",
	"./freshwater/chinook-salmon/2.jpg": "8434",
	"./freshwater/goldfish/2.jpg": "d308",
	"./freshwater/koi-carp/2.jpg": "59c3",
	"./freshwater/red-bellied-piranha/2.jpg": "703c",
	"./freshwater/redtail-catfish/2.jpg": "00b7",
	"./freshwater/smalltooth-sawfish/2.jpg": "89dc",
	"./ocean/bottlenose-dolphin/2.jpg": "29c0",
	"./ocean/box-jellyfish/2.jpg": "3d1b",
	"./ocean/giant-pacific-octopus/2.jpg": "ecce",
	"./ocean/gray-seal/2.jpg": "cac2",
	"./ocean/green-sea-turtle/2.jpg": "2d8c",
	"./ocean/humboldt-penguin/2.jpg": "0aed",
	"./ocean/manta-ray/2.jpg": "8901",
	"./ocean/starfish/2.jpg": "2725",
	"./saltwater/atlantic-tarpon/2.jpg": "4b9b",
	"./saltwater/butterflyfish/2.jpg": "4366",
	"./saltwater/clownfish/2.jpg": "283a",
	"./saltwater/emperor-angelfish/2.jpg": "5599",
	"./saltwater/hippo-tang/2.jpg": "1314",
	"./saltwater/longhorn-cowfish/2.jpg": "c2c5",
	"./saltwater/red-lionfish/2.jpg": "0339",
	"./saltwater/yellow-surgeonfish/2.jpg": "03ae",
	"./shark/blacktip-shark/2.jpg": "84fd",
	"./shark/bull-shark/2.jpg": "2906",
	"./shark/nurse-shark/2.jpg": "db50",
	"./shark/oceanic-whitetip-shark/2.jpg": "89fb",
	"./shark/pelagic-thresher-shark/2.jpg": "f355",
	"./shark/scalloped-hammerhead-shark/2.jpg": "a35f",
	"./shark/whale-shark/2.jpg": "6fcd",
	"./shark/zebra-shark/2.jpg": "e34c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5b91";